import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Products", to: "/products" },
  { label: "Blog", to: "/blog" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Podcasts", to: "/podcasts" },
  { label: "Contact Us", to: "/contact" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 24);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [loc.pathname, loc.hash]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-midnight/85 backdrop-blur-xl border-b border-gold/15"
          : "bg-transparent"
      }`}
    >
      <div className="wrap flex items-center justify-between py-4">
        <Link
          to="/"
          data-testid="nav-logo"
          className="group flex items-center gap-3"
        >
          <span className="relative flex h-9 w-9 items-center justify-center">
            <span className="absolute inset-0 rounded-full border border-gold/60" />
            <span className="absolute inset-1.5 rounded-full border border-gold/40" />
            <span className="absolute inset-3 rounded-full bg-gold/80" />
          </span>
          <span className="leading-tight">
            <span className="block font-display text-lg tracking-wide text-ivory">
              Geomantic <span className="text-gold">Kalpataru</span>
            </span>
            <span className="block text-[10px] uppercase tracking-[0.3em] text-ivory/50">
              Ancient · Manifestation
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-2">
          {NAV.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-4 py-2 text-[12px] uppercase tracking-[0.22em] transition ${
                  isActive ? "text-gold" : "text-ivory/70 hover:text-gold"
                }`
              }
              end={item.to === "/"}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link to="/contact" data-testid="nav-cta-consult" className="btn-gold">
            Book Consultation
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-ivory p-2"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-gold/15 bg-midnight/95 backdrop-blur-xl"
        >
          <div className="wrap py-6 grid gap-2">
            {NAV.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="block py-3 text-base text-ivory/85 border-b border-gold/10 hover:text-gold"
                data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/contact"
              className="btn-gold mt-4 justify-center"
              data-testid="mobile-cta-consult"
            >
              Book Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
